import { MicrosoftOutlookLinkedService } from 'app/model/linkedservice/microsoftoutlook.linkedservice';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from '../adapter-registry';
import { WebActivityLinkedServiceAdapter } from './web-activity-linkedservice.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MicrosoftOutlookLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                authentication: '*',
                baseUrl: '*',
                username: '*',
                resource: '*',
                userTenant: '*',
                password: 'secret',
                pfx: 'secret',
                credential: '*',
                enableServerCertificateValidation: '*'
            },
            parameters: '*'
        }
    }
})
export class MicrosoftOutlookLinkedServiceAdapter extends WebActivityLinkedServiceAdapter {
    protected modelConstructor(): new () => MicrosoftOutlookLinkedService {
        return MicrosoftOutlookLinkedService;
    }

    protected model(): IModel {
        return MicrosoftOutlookLinkedService.MODEL;
    }
}
